<template>
  <div id="my_account">
    <div class="info">
      <div class="avatar">
        <img v-if="userInfo.touxiang" :src="userInfo.touxiang" alt="">
        <img v-else src="@/assets/logo/logo.svg" alt="">
        <div v-if="auth_state === 0" class="real_name">未实名</div>
        <div v-else class="real_name">已实名</div>
      </div>
      <div class="info_content">
        <div class="info_content_text">
          <div id="userName">{{ this.$store.state.userData.nickname }}</div>
          <div id="balance">账户余额：<span>¥<strong>{{ userInfo.freeAmount }}</strong></span></div>
          <div id="frozenAmount">冻结余额：¥{{ userInfo.frozenAmount }}</div>
        </div>
        <div class="info_content_btn">
          <div class="modify_info" @click="modifyInfo">
            <i class="el-icon-edit-outline"></i>
            <span >修改信息</span>
          </div>
          <div class="view_details" @click="viewDetails">
            <i class="el-icon-document"></i>
            <span >查看明细</span>
          </div>
        </div>
      </div>
      <div class="btn_ground" >
        <div class="recharge" @click="clickRecharge">我要充值
          <div class="inDev" @click.stop>
            <div class="inDev_tip">
              <i class="el-icon-warning-outline"></i>
              <div>平台账号充值提现开发中，目前<span>支持至银行、支付宝、微信放款</span>，财务将会在交易完成后放款到您指定的账户～</div>
            </div>
          </div>
        </div>
        <div class="withdraw" @click="clickWithdraw">我要提现
          <div class="inDev" @click.stop>
            <div class="inDev_tip">
              <i class="el-icon-warning-outline"></i>
              <div>平台账号充值提现开发中，目前<span>支持至银行、支付宝、微信放款</span>，财务将会在交易完成后放款到您指定的账户～</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="seller_info">
      <div class="title">
        <div class="title_left">
          <div class="title_item">
            <i class="el-icon-s-shop"></i>
          </div>
          我是卖家
        </div>
        <router-link class="title_right" :to="{name:'AccountSell'}">
          <span>去卖号</span>
          <i class="el-icon-arrow-right"></i>
        </router-link>
        <!--        <div class="title_right" @click="clickSellItem('全部')">我要卖号</div>-->
      </div>
      <div class="seller_info_content">
        <!-- 降价请求 -->
        <router-link :to="{name:'Seller'}" class="seller_info_content_item">
          <div class="item_num">{{ userInfo.productTotal }}</div>
          <div class="item_text">发布的账号</div>
        </router-link>
        <!-- 降价请求 -->
        <router-link :to="{name:'SellerGold'}" class="seller_info_content_item">
          <div class="item_num">{{ userInfo.goldTotal }}</div>
          <div class="item_text">发布的金币</div>
        </router-link>
        <!-- 降价请求 -->
        <router-link :to="{name:'SellerEquip'}" class="seller_info_content_item">
          <div class="item_num">{{ userInfo.equipTotal }}</div>
          <div class="item_text">发布的装备</div>
        </router-link>
        <!-- 降价请求 -->
        <router-link :to="{name:'SellerBargain'}" class="seller_info_content_item">
          <div class="item_num">{{ userInfo.priceRequestSale }}</div>
          <div class="item_text">降价请求</div>
        </router-link>
      </div>
    </div>
    <div class="buyer_info">
      <div class="title">
        <div class="title_left">
          <div class="title_item">
            <i class="el-icon-shopping-cart-full"></i>
          </div>
          我是买家
        </div>
        <router-link class="title_right" :to="{name:'AllGame'}">
          <span>去买号</span>
          <i class="el-icon-arrow-right"></i>
        </router-link>
        <!--        <div class="title_right" @click="clickBuyItem('已成交')">我要买号</div>-->
      </div>
      <div class="buyer_info_content">
        <!-- 账号订单 -->
        <router-link :to="{name:'Buyer'}" class="buyer_info_content_item">
          <div class="item_num">{{ userInfo.buyProduct }}</div>
          <div class="item_text">账号订单</div>
        </router-link>
        <!-- 金币订单 -->
        <router-link :to="{name:'BuyerGold'}" class="buyer_info_content_item">
          <div class="item_num">{{ userInfo.buyGold }}</div>
          <div class="item_text">金币订单</div>
        </router-link>
        <!-- 装备订单 -->
        <router-link :to="{name:'BuyerEquip'}" class="buyer_info_content_item">
          <div class="item_num">{{ userInfo.buyEquip }}</div>
          <div class="item_text">装备订单</div>
        </router-link>
        <!-- 我的收藏 -->
        <router-link :to="{name:'MyCollection'}" class="buyer_info_content_item">
          <div class="item_num">{{ userInfo.collect }}</div>
          <div class="item_text">我的收藏</div>
        </router-link>
        <!-- 发出的求降 -->
        <router-link :to="{name:'BuyerBargain'}" class="buyer_info_content_item">
          <div class="item_num">{{ userInfo.priceRequestBuy }}</div>
          <div class="item_text">发出的求降价</div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import {apiuserInfo, apiuserInformation} from "@/request/API";

export default {
  name: '',
  props: {},
  components: {},
  data() {
    return {
      //用户信息
      userInfo: {},
      //实名认证
      auth_state: '',
    }
  },
  methods: {
    //修改信息点击事件
    modifyInfo() {
      this.$router.push({
        path: '/personalCenter/personalInfo'
      });
    },
    //查看明细点击事件
    viewDetails() {
      this.$router.push({
        path: '/personalCenter/financialCenter/moneyDetails'
      });
    },
    //我要充值点击事件
    clickRecharge() {
      this.$router.push({
        path: '/personalCenter/financialCenter',
      });
    },
    //我要提现点击事件
    clickWithdraw() {
      this.$router.push({
        path: '/personalCenter/financialCenter/withdraw',
      });
    },
    //我是卖家item点击事件
    clickSellItem(param, index) {
      this.$router.push({
        path: '/personalCenter/seller',
        name: 'Seller',
        params: {
          selectItem: param,
          selectItemIndex: index,
        }
      });
    },
    //我是买家item点击事件
    clickBuyItem(param, index) {
      this.$router.push({
        path: '/personalCenter/buyer',
        name: 'Buyer',
        params: {
          selectItem: param,
          selectItemIndex: index,
        }
      });

    },
    //我的收藏item点击事件
    clickCollectionItem(param) {
      this.$router.push({
        path: '/personalCenter/myCollection',
        name: 'MyCollection',
        params: {
          selectItem: param
        }
      });

    },
    //计算开发倒计时天数
    getDevDays(dateString1, dateString2) {
      var startDate = dateString1;
      var endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      return parseInt(days);
    },
    //初始化数据
    onLoad() {
      apiuserInformation({}).then(res => {
        this.userInfo = res.data
      })
      apiuserInfo({
        action: 'verified'
      }).then(res => {
        this.auth_state = res.data.auth_state
      })
    }
  },
  mounted() {
    //初始化数据
    this.onLoad()
  },
  watch: {},
  computed: {}
}
</script>

<style lang='less' scoped>
#my_account {
  min-height: max(680px, calc(100vh - 430px));
  padding: 22px;
  background: transparent;
  box-sizing: border-box;

  .info {
    min-height: 148px;
    margin: -22px -22px 24px;
    padding: 26px 30px;
    display: flex;
    align-items: center;
    border-radius: 4px 4px 0 0;
    background: var(--bg-dark, #1A1D24);
    box-shadow: 0 6px 14px rgba(26, 29, 36, 0.1);
    box-sizing: border-box;

    .avatar {
      width: 80px;
      height: 80px;
      flex: 0 0 80px;
      padding: 8px;
      border: 3px solid rgba(255, 255, 255, 0.78);
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.96);
      position: relative;
      box-shadow: 0 10px 22px rgba(15, 23, 42, 0.16);
      box-sizing: border-box;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 50%;
      }

      .real_name {
        min-width: 70px;
        height: 22px;
        padding: 0 10px;
        background: rgba(255, 255, 255, 0.96);
        border-radius: 4px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: var(--text-main, #1A1D24);
        line-height: 22px;
        text-align: center;
        position: absolute;
        left: 50%;
        bottom: -10px;
        transform: translateX(-50%);
        box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);
        box-sizing: border-box;
        white-space: nowrap;
      }
    }

    .info_content {
      flex: 1;
      min-width: 0;
      margin-left: 28px;
      display: flex;
      align-items: center;

      .info_content_text {
        width: 260px;
        min-width: 260px;

        #userName {
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 28px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        #balance {
          font-size: 16px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.82);
          line-height: 30px;

          span {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: var(--primary, #FF5A1F);
            line-height: 30px;

            strong {
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: var(--primary, #FF5A1F);
              line-height: 34px;
            }
          }
        }

        #frozenAmount {
          font-size: 16px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.74);
          line-height: 24px;
        }
      }

      .info_content_btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 12px;
        font-size: 14px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.88);
        line-height: 20px;

        .modify_info,
        .view_details {
          width: 104px;
          height: 34px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          border-radius: 4px;
          background: rgba(255, 255, 255, 0.14);
          border: 1px solid rgba(255, 255, 255, 0.2);
          cursor: pointer;
          transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;

          i {
            font-size: 16px;
          }

          &:hover {
            color: #FFFFFF;
            background: rgba(255, 255, 255, 0.22);
          }
        }
      }
    }

    .btn_ground {
      width: 176px;
      flex: 0 0 176px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      > div {
        width: 176px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 600;
        box-sizing: border-box;
      }

      .recharge,
      .withdraw {
        background: var(--primary, #FF5A1F);
        color: #FFFFFF;
        position: relative;
        box-shadow: 0 10px 20px rgba(249, 115, 22, 0.22);
        transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;

        &:before {
          content: "";
          width: 18px;
          height: 100%;
          position: absolute;
          top: 0;
          right: 100%;
        }

        .inDev {
          width: 330px;
          min-height: 112px;
          display: none;
          position: absolute;
          top: 50%;
          right: 194px;
          padding: 16px 18px;
          background: var(--bg-card, #FFFFFF);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          box-shadow: 0 12px 28px rgba(26, 29, 36, 0.14);
          box-sizing: border-box;
          transform: translateY(-50%);
          z-index: 3;

          &:after {
            content: "";
            width: 12px;
            height: 12px;
            position: absolute;
            right: -7px;
            top: 50%;
            background: var(--bg-card, #FFFFFF);
            border-top: 1px solid var(--border-soft, #E8E4DE);
            border-right: 1px solid var(--border-soft, #E8E4DE);
            transform: translateY(-50%) rotate(45deg);
          }

          .inDev_tip {
            width: 100%;
            font-size: 14px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            line-height: 22px;
            display: flex;
            align-items: flex-start;
            text-align: left;

            > i {
              width: 46px;
              height: 46px;
              flex: 0 0 46px;
              margin-right: 14px;
              border-radius: 4px;
              background: var(--primary-soft, #FCEDE5);
              color: var(--primary, #FF5A1F);
              font-size: 26px;
              line-height: 46px;
              text-align: center;
            }

            div {
              flex: 1;
              min-width: 0;
              height: auto;
              font-size: 14px;
              line-height: 22px;
              text-align: left;
              cursor: default;
            }

            span {
              color: var(--primary, #FF5A1F);
              font-family: PingFangSC-Medium, PingFang SC;
            }
          }
        }
      }

      .recharge:hover,
      .withdraw:hover {
        transform: translateY(-1px);

        .inDev {
          display: block;
        }
      }

      .withdraw {
        border: 1px solid rgba(255, 255, 255, 0.72);
        color: #FFFFFF;
        background: transparent;
        box-shadow: none;

        &:hover {
          border-color: #FFFFFF;
          background: rgba(255, 255, 255, 0.12);
        }
      }
    }
  }

  .seller_info,
  .buyer_info {
    min-height: 172px;
    padding: 0 0 24px;
    background: transparent;
    border: none;
    box-shadow: none;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  .seller_info {
    margin-bottom: 18px;
    border-bottom: 1px solid var(--border-soft, #E8E4DE);
  }

  .seller_info_content,
  .buyer_info_content {
    display: flex;
    gap: 14px;

    .seller_info_content_item,
    .buyer_info_content_item {
      flex: 1;
      min-width: 0;
      height: 96px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      border: 1px solid var(--border-soft, #E8E4DE);
      background: var(--bg-tag, #F0EDE8);
      cursor: pointer;
      box-sizing: border-box;
      transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

      .item_num {
        max-width: 100%;
        margin-bottom: 8px;
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: var(--text-main, #111827);
        line-height: 34px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .item_text {
        max-width: 100%;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: var(--text-secondary, #5A5F6B);
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &:hover {
        border-color: rgba(26, 29, 36, 0.32);
        background: var(--bg-tag, #F0EDE8);
        box-shadow: 0 6px 14px rgba(26, 29, 36, 0.06);
        transform: translateY(-2px);

        .item_num {
          color: var(--text-main, #1A1D24);
        }
      }
    }
  }

  .title {
    height: 52px;
    margin: 0;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: var(--text-main, #111827);
    line-height: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title_left {
      display: flex;
      align-items: center;

      .title_item {
        width: 34px;
        height: 34px;
        margin-right: 10px;
        border-radius: 4px;
        background: var(--bg-tag, #F0EDE8);
        color: var(--text-main, #1A1D24);
        line-height: 34px;
        text-align: center;

        i {
          font-size: 18px;
        }
      }
    }

    .title_right {
      display: flex;
      align-items: center;
      gap: 6px;
      height: 34px;
      padding: 0 14px;
      border: 1px solid rgba(26, 29, 36, 0.18);
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 600;
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
      transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;

      i {
        font-size: 14px;
        transition: transform 0.2s ease;
      }
    }

    .title_right:hover {
      color: var(--text-main, #1A1D24);
      border-color: rgba(26, 29, 36, 0.34);
      background: var(--bg-tag, #F0EDE8);
      box-shadow: 0 0 0 3px rgba(26, 29, 36, 0.08), 0 8px 18px rgba(26, 29, 36, 0.1);

      i {
        transform: translateX(2px);
      }
    }
  }
}
</style>
